import React from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { trainings } from 'redux/modules'
import Loader from './Loader'

const TrainingLoader = props => {
  const {
    children,
    trainingUuid,
    fetchTraining,
    activeLanguage: { code: locale },
    ...restProps
  } = props

  const fetchMethod = params => fetchTraining(trainingUuid, { ...params, locale })
  const triggers = [trainingUuid, locale]

  return (
    <Loader fetchMethod={fetchMethod} triggers={triggers} {...restProps}>
      {children}
    </Loader>
  )
}

TrainingLoader.propTypes = {
  children: PropTypes.node.isRequired,
  trainingUuid: PropTypes.string.isRequired,
  fetchTraining: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
}

export default compose(
  connect(
    null,
    { fetchTraining: trainings.fetchTraining }
  ),
  withLocalize
)(TrainingLoader)
